import CitySEOHead from "@/components/feature/CitySEOHead";
import HinesvilleHeroSection from "./components/HeroSection";
import HinesvilleStickyNav from "./components/StickyNav";
import HinesvilleProcessingTimeSection from "./components/ProcessingTimeSection";
import HinesvilleServicesSection from "./components/ServicesSection";
import HinesvilleLocalAreaSection from "./components/LocalAreaSection";
import HinesvilleTestimonialsSection from "./components/TestimonialsSection";
import HinesvilleAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import HinesvilleComparisonSection from "./components/ComparisonSection";
import HinesvilleMistakesSection from "./components/MistakesSection";
import HinesvilleHowItWorksSection from "./components/HowItWorksSection";
import HinesvilleFAQSection, { faqs } from "./components/FAQSection";
import HinesvilleHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import HinesvilleFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const servicesSchema = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function HinesvillePage() {
  return (
    <>
      <CitySEOHead
        city="Hinesville"
        state="Georgia"
        stateAbbr="GA"
        route="/hinesville"
        title="Emergency Passport Hinesville, GA — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Hinesville, GA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Liberty County, Fort Stewart, and coastal Georgia travelers. Get your emergency passport fast!"
        geoPlacename="Hinesville, Georgia"
        geoPosition="31.8469;-81.5960"
        faqs={faqs}
        servicesSchema={servicesSchema}
        statePageName="Georgia"
        statePageRoute="/states/georgia"
        keywords="expedited passport, emergency passport, Hinesville passport, same day passport Hinesville, fast passport Georgia, Liberty County passport, Fort Stewart passport"
      />
      <div className="font-sans">
        <HinesvilleHeroSection />
        <HinesvilleStickyNav />
        <HinesvilleProcessingTimeSection />
        <HinesvilleLocalAreaSection />
        <HinesvilleServicesSection />
        <HinesvilleTestimonialsSection />
        <HinesvilleAcceptanceFacilitiesSection />
        <HinesvilleComparisonSection />
        <HinesvilleMistakesSection />
        <HinesvilleHowItWorksSection />
        <HinesvilleFAQSection />
        <HinesvilleHelpfulResourcesSection />
        <SEOCrossLinks currentRoute="/cities/hinesville" state="GA" />
        <HinesvilleFinalCTA />
      </div>
    </>
  );
}